import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'Mail',
      label: 'Email',
      value: 'mikeoforka7@gmail.com',
      href: 'mailto:mikeoforka7@gmail.com',
      description: 'Primary contact method - Response within 24 hours'
    },
    {
      icon: 'Phone',
      label: 'Phone',
      value: '+234 9040744911',
      href: 'tel:+2349040744911',
      description: 'Available Mon-Fri, 9 AM - 6 PM EST'
    },
    {
      icon: 'Linkedin',
      label: 'LinkedIn',
      value: 'linkedin.com/in/mikedev',
      href: 'https://linkedin.com/in/mikedev',
      description: 'Professional networking and quick messages'
    },
    {
      icon: 'Calendar',
      label: 'Schedule Call',
      value: 'Book 30-min consultation',
      href: 'https://calendly.com/mikedev',
      description: 'Free discovery call to discuss your project'
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground mb-3">
          Get In Touch
        </h2>
        <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
          Ready to start your project? Choose your preferred contact method below. I typically respond within 24 hours during business days.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-4">
        {contactMethods?.map((method, index) => (
          <a
            key={index}
            href={method?.href}
            target={method?.icon === 'Linkedin' || method?.icon === 'Calendar' ? '_blank' : undefined}
            rel={method?.icon === 'Linkedin' || method?.icon === 'Calendar' ? 'noopener noreferrer' : undefined}
            className="flex items-start gap-4 p-4 md:p-5 lg:p-6 rounded-lg bg-card border border-border hover:border-primary hover:shadow-lg transition-all duration-300 group"
          >
            <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors duration-300 flex-shrink-0">
              <Icon name={method?.icon} size={24} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground">
                  {method?.label}
                </h3>
                <Icon name="ExternalLink" size={16} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <p className="text-sm md:text-base text-primary font-medium mb-1 break-all">
                {method?.value}
              </p>
              <p className="text-xs md:text-sm text-muted-foreground">
                {method?.description}
              </p>
            </div>
          </a>
        ))}
      </div>
      <div className="p-4 md:p-5 lg:p-6 rounded-lg bg-success/10 border border-success/20">
        <div className="flex items-start gap-3">
          <div className="w-2 h-2 rounded-full bg-success animate-pulse-glow mt-1.5 flex-shrink-0" />
          <div>
            <h3 className="text-base md:text-lg font-bold font-heading text-foreground mb-2">
              Currently Available
            </h3>
            <p className="text-sm md:text-base text-muted-foreground mb-3">
              Accepting new projects starting February 2025. Limited slots available for Q1 2025.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 rounded-full bg-success/20 text-success text-xs md:text-sm font-medium">
                2 slots remaining
              </span>
              <span className="px-3 py-1 rounded-full bg-muted text-muted-foreground text-xs md:text-sm font-medium">
                Next available: Feb 1, 2025
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6 rounded-lg bg-card border border-border">
        <h3 className="text-base md:text-lg font-bold font-heading text-foreground mb-3">
          Office Hours & Response Time
        </h3>
        <div className="space-y-2 text-sm md:text-base text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={16} className="text-primary flex-shrink-0" />
            <span>Monday - Friday: 9:00 AM - 6:00 PM EST</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Globe" size={16} className="text-primary flex-shrink-0" />
            <span>Time Zone: Eastern Standard Time (UTC-5)</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="MessageSquare" size={16} className="text-primary flex-shrink-0" />
            <span>Response Time: Within 24 hours on business days</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Zap" size={16} className="text-primary flex-shrink-0" />
            <span>Emergency Support: Available for active clients</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;